import { TypographyV2 as Typography } from '@which/seatbelt';
import styles from './ResultsCard.module.scss';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ResultsCard = _ref => {
  let {
    title,
    details
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Typography, {
      textStyle: "sb-text-heading-small",
      children: title
    }), /*#__PURE__*/_jsx("dl", {
      className: styles.definitionList,
      children: Object.entries(details).map(_ref2 => {
        let [label, value] = _ref2;
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("dt", {
            children: [label, ": "]
          }), /*#__PURE__*/_jsx("dd", {
            children: value
          })]
        }, label);
      })
    })]
  });
};

///////// IMPLEMENTATION /////////